import {AfterViewChecked, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DetailedRegistration, Registration} from '../datamodel/registration';
import {Course, DetailedCourse} from '../datamodel/course';
import {CourseUnit} from '../datamodel/course-unit';
import {ClassGroup} from '../datamodel/class-group';
import {LeftMenuService} from '../left-menu.service';
import {BackendService} from '../backend.service';

@Component({
  selector: 'app-classgroup',
  templateUrl: './classgroup.component.html',
  styleUrls: ['./classgroup.component.css']
})
export class ClassgroupComponent implements OnInit {

  registration: DetailedRegistration;
  course: DetailedCourse;
  unit: CourseUnit;
  classgroup: ClassGroup;
  registeredCount?: number;

  constructor(public router: ActivatedRoute, public menu: LeftMenuService, public backend: BackendService) {
  }

  ngOnInit() {
    const registrationId = decodeURIComponent(this.router.snapshot.paramMap.get('id'));
    const unitId = Number(this.router.snapshot.paramMap.get('unit_id'));
    const groupNumber = Number(this.router.snapshot.paramMap.get('group_number'));
    const courseGroupId = this.router.snapshot.paramMap.get('course_group_id');

    this.backend.getRegisteredCount(registrationId).subscribe(data => this.registeredCount = data.get(unitId, groupNumber));

    this.router.data.subscribe(data => {
        this.registration = data.registration;

        this.course = data.course;
        this.unit = this.course.courseUnits.find(unit => unit.id === unitId);
        this.classgroup = this.unit.classGroups.find(group => group.number === groupNumber);
        this.menu.addPath([this.registration, this.registration.getCourseGroup(courseGroupId), this.course, this.classgroup]);
      }
    );
  }
}
